"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryEvent = void 0;
const Constants_1 = require("../Constants");
const EventBase_1 = require("./EventBase");
/**
 * Describes a BPMN BoundaryEvent.
 *
 * These events are always attached to an activity and will only live
 * as long as that activity gets executed.
 */
class BoundaryEvent extends EventBase_1.Event {
    get bpmnType() {
        return Constants_1.BpmnType.boundaryEvent;
    }
    get eventType() {
        const eventIsErrorEvent = this.errorEventDefinition !== undefined;
        if (eventIsErrorEvent) {
            return Constants_1.EventType.errorEvent;
        }
        const eventIsMessageEvent = this.messageEventDefinition !== undefined;
        if (eventIsMessageEvent) {
            return Constants_1.EventType.messageEvent;
        }
        const eventIsSignalEvent = this.signalEventDefinition !== undefined;
        if (eventIsSignalEvent) {
            return Constants_1.EventType.signalEvent;
        }
        const eventIsTimerEvent = this.timerEventDefinition !== undefined;
        if (eventIsTimerEvent) {
            return Constants_1.EventType.timerEvent;
        }
        return undefined;
    }
}
exports.BoundaryEvent = BoundaryEvent;
//# sourceMappingURL=BoundaryEvent.js.map